



































































import { PartyModel, TownModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Guid } from '@/libs/common/functions/guid';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { townsStore } from '@/libs/towns/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { partiesStore } from '@/libs/parties/+state/store';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({})
export default class TownDialog extends Page {

    dialog = false;
    valid = true;
    saving = false;
    item: TownModel | null = null;
    priceSuffix = "";
    deleteDialog = false;
    deleting = false;
    existingPartiesDialog = false;
    existingTownsDialog = false;

    get isNewItem() : boolean {
        return this.item?.id == Guid.EmptyGuid();
    }

    @Watch("dialog")
    dialogChanged(v: boolean) {
        if (!v)
            this.close();
    }

    @Prop() districtId!: string;

    @Ref() form!: any;

    load(id: string | null) {
        if (id == null || id == Guid.EmptyGuid()) {
            this.item = {
                id: Guid.EmptyGuid(),
                name: "",
                position: 1,
                isActive: true,
                districtId: this.districtId
            } as TownModel;
        }
        else {
            townsStore.dispatch(CrudAction.Get, { id: id });
            this.subscribe(townsStore, CrudReponse.Get).then((e: TownModel) => {
                this.item = e;
            });
        }
    }

    open (id: string | null = null) {
        this.dialog = true;
        this.load(id);
    }

    close () {
        this.dialog = false;
    }

    save () {
        if (this.form.validate()) {
            this.saving = true;
            if (this.item!.id == Guid.EmptyGuid()) {
                townsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TownModel>(undefined, [
                    { field: "name", op: "eq", comparand: this.item!.name!, junction: "or" }
                ], { pageIndex: 1, pageSize: 1 }, false, "ExistingTownName"));
                this.subscribe(townsStore, CrudReponse.GetAll, "ExistingTownName").then((existingTowns: TownModel[]) => {
                    if (!existingTowns.any()) {
                        townsStore.dispatch(CrudAction.Create, { item: this.item });
                        this.subscribe(townsStore, CrudReponse.Create).then((e: TownModel) => {
                            this.saving = false;
                            this.close();
                        }).catch((e: any) => {
                            this.saving = false;
                        });
                    }
                    else {
                        this.existingTownsDialog = true;
                        this.saving = false;
                    }
                }).catch((e: any) => {
                    this.saving = false;
                });
            }
            else {
                townsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TownModel>(undefined, [
                    { field: "name", op: "eq", comparand: this.item!.name! },
                    { field: "id", op: "ne", comparand: this.item!.id! }
                ], { pageIndex: 1, pageSize: 1 }, false, "ExistingTownName"));
                this.subscribe(townsStore, CrudReponse.GetAll, "ExistingTownName").then((existingTowns: TownModel[]) => {
                    if (!existingTowns.any()) {
                        townsStore.dispatch(CrudAction.Update, { item: this.item });
                        this.subscribe(townsStore, CrudReponse.Update).then((e: TownModel) => {
                            this.saving = false;
                            this.close();
                        }).catch((e: any) => {
                            this.saving = false;
                        });
                    }
                    else {
                        this.existingTownsDialog = true;
                        this.saving = false;
                    }
                }).catch((e: any) => {
                    this.saving = false;
                });
            }
        }
    }

    deleteClick () {
        this.deleteDialog = true;
    }

    deleteItem () {
        this.deleting = true;
        partiesStore.dispatch(CrudAction.GetAllBasic, createCrudQueryPayload<PartyModel>(undefined, [
            { field: "townId", op: "eq", comparand: this.item!.id!, junction: "or" }
        ], { pageIndex: 1, pageSize: 1 }, false, "DeleteTown"));
        this.subscribe(partiesStore, CrudReponse.GetAllBasic, "DeleteTown").then((existingParties: PartyModel[]) => {
            if (!existingParties.any()) {
                townsStore.dispatch(CrudAction.Delete, { id: this.item?.id });
                this.subscribe(townsStore, CrudReponse.Delete).then((e: TownModel) => {
                    this.deleting = false;
                    this.deleteDialog = false;
                    this.close();
                }).catch((e: any) => {
                    this.deleting = false;
                });
            }
            else {
                this.existingPartiesDialog = true;
                this.deleting = false;
                this.deleteDialog = false;
            }
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

}
